import { heroStory, hotSearch } from "@/mocks/gossip";
import { Tag } from "./ui";

function HotWords() {
  const heatColors = [
    "bg-primary-100 text-primary-700",
    "bg-accent-100 text-accent-800",
    "bg-secondary-100 text-secondary-800",
  ];
  return (
    <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center gap-2">
        <i className="ri-fire-fill text-lg text-primary-500" />
        <h3 className="font-heading text-base font-bold text-foreground-950">全网热搜 · 此刻在追</h3>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {hotSearch.map((h, i) => (
          <a
            key={h.word}
            href="#news"
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition hover:opacity-80 ${heatColors[i % 3]}`}
          >
            <i className="ri-arrow-up-line text-[10px]" />
            {h.word}
            <span className="opacity-70">{h.heat}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-gradient-to-b from-primary-50/70 via-background-50 to-background-50">
      {/* 顶部大头条 */}
      <div className="mx-auto max-w-[1200px] px-4 pb-10 pt-8 md:px-6 md:pb-14 md:pt-12">
        <article className="grid gap-7 lg:grid-cols-12 lg:items-start">
          {/* 左侧主图故事 */}
          <div className="lg:col-span-8">
            <a href="#star" className="group block overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative aspect-[16/9] w-full overflow-hidden">
                <img
                  src={heroStory.image}
                  alt="刚刚爆料独家现场——《烟雨长街》开机八卦热点大图"
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute h-full w-full animate-ping rounded-full bg-background-50/70" />
                    <span className="relative h-2 w-2 rounded-full bg-background-50" />
                  </span>
                  {heroStory.kicker}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                  <div className="mb-2 flex flex-wrap items-center gap-2">
                    <Tag tone="accent">{heroStory.tag}</Tag>
                    <span className="text-xs text-background-50/80">
                      <i className="ri-time-line mr-1" />
                      {heroStory.time}
                    </span>
                    <span className="text-xs text-background-50/80">
                      <i className="ri-book-read-line mr-1" />
                      {heroStory.readText}
                    </span>
                  </div>
                  <h1 className="font-heading text-xl font-black leading-snug text-background-50 md:text-3xl md:leading-snug">
                    {heroStory.title}
                  </h1>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-sm leading-7 text-foreground-600 md:text-[15px]">{heroStory.lead}</p>
                <a
                  href="#star"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition hover:gap-2 hover:text-primary-700"
                >
                  展开吃瓜
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </a>
          </div>

          {/* 右侧要点与热搜 */}
          <div className="space-y-6 lg:col-span-4">
            <div className="rounded-2xl border border-background-200 bg-background-100/70 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">事件拆解 · 三问</h3>
                <span className="text-xs text-foreground-400">刚刚整理</span>
              </div>
              <div className="mt-4 space-y-4">
                {heroStory.list.map((it) => (
                  <a key={it.rank} href="#impact" className="group flex gap-4 border-b border-background-200 pb-4 last:border-0 last:pb-0">
                    <span className="font-heading text-2xl font-black leading-none text-primary-500/80">{it.rank}</span>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 transition group-hover:text-primary-700">{it.title}</h4>
                      <p className="mt-1 text-xs leading-6 text-foreground-500">{it.desc}</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>
            <HotWords />
          </div>
        </article>
      </div>
    </section>
  );
}